export const BLOCKER_STATE = {
  BLOCKED: 'blocked',
  UNBLOCKED: 'unblocked',
}
